<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import Link from "../components/Link.svelte";
	import translations from "./Software.translations.json";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import { getTranslate } from "../utils/getTranslate.js";
	import ContactForm from "../components/Contact/ContactForm.svelte";
	import SoftwareMockup from "../components/SoftwareMockup.svelte";
	import { getTenant } from "../getTenant.js";
	import { vertiNodeUrlMap } from "../../../core/schema/urls/vertiNodeUrlMap.js";

	const translate = getTranslate(translations);
	const tenant = getTenant();
</script>

<Layout>
	<div class="container">
		<section class="mx-4 !mb-12 md:mx-16 md:!mb-24 xl:mx-32">
			<div class="flex flex-col gap-8 xl:flex-row xl:gap-32">
				<div class="order-2 w-full flex-1 xl:order-1">
					<SoftwareMockup class="h-auto w-full lg:mt-8 xl:sticky xl:top-48 xl:mt-20" />
				</div>

				<div class="text-ltsecondary order-1 flex flex-1 flex-col justify-center xl:order-2 xl:justify-start">
					<div class="flex items-center gap-4 pb-16">
						<span class="bg-ltprimary-200 h-px w-8"></span>
						<span class="text-ltprimary-200 uppercase">{translate("tag")}</span>
					</div>
					<h1 class="text-ltprimary m-0 mb-8 p-0 text-center uppercase tracking-wider lg:text-left">
						<span class="font-semibold">
							{translate("vertinode")}
						</span>
						<br />
						<span class="font-light">
							{translate("headline")}
						</span>
					</h1>

					<p class="lg:!text-md/normal mx-auto tracking-[0.02em]">
						{translate("paragraph1")}
					</p>
					<p class="lg:!text-md/normal mx-auto tracking-[0.02em]">
						{translate("paragraph2")}
					</p>
					<p class="lg:!text-md/normal mx-0 !mb-0 tracking-[0.02em]">
						{translate("subheadline")}
					</p>
					<p class="lg:!text-md/normal mx-auto tracking-[0.02em]">
						{translate("paragraph3")}
					</p>
					<div class="mt-3 flex lg:mt-8 xl:mt-16">
						<Link asButton variant="secondary" icon={arrowRight} href={vertiNodeUrlMap[tenant.locale]} target="_blank">
							{translate("moreAboutVertinode")}
						</Link>
					</div>
				</div>
			</div>
		</section>
	</div>

	<section class="!mb-0">
		<ContactForm />
	</section>
</Layout>
